import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { Close } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';

interface DeletedAnnotationDialogProps {
  onClose: () => void;
  dialogState: DeletedAnnotationDialogState;
}

export interface DeletedAnnotationDialogState {
  open: boolean;
  type: 'annotation' | 'comment';
}

const DeletedAnnotationDialog: React.FunctionComponent<DeletedAnnotationDialogProps> = ({
  onClose,
  dialogState: { open, type }
}) => {
  const { paper, title, content, actions } = useStyles();
  const typeStirng = type === 'annotation' ? '주석' : '답글';

  const dialogContent = (
    <>
      <DialogTitle className={title} disableTypography>
        <CustomizedTypography variant="h4" fontWeight="700">
          삭제된 {typeStirng}
        </CustomizedTypography>
        <IconButton className="close-button" onClick={onClose}>
          <Close size={24} color={colorSet.gray900} />
        </IconButton>
      </DialogTitle>

      <DialogContent className={content}>
        <CustomizedTypography variant="subtitle1" color="textPrimary">
          해당 {typeStirng}이 삭제되어 확인할 수 없습니다.
        </CustomizedTypography>
      </DialogContent>

      <DialogActions className={actions}>
        <CustomizedButton
          color="primary"
          variant="contained"
          fullWidth
          size="large"
          onClick={onClose}
        >
          닫기
        </CustomizedButton>
      </DialogActions>
    </>
  );

  return (
    <Dialog classes={{ paper }} open={open} onClose={onClose}>
      {dialogContent}
    </Dialog>
  );
};

export default DeletedAnnotationDialog;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '476px',
    minWidth: '343px',
    width: '100%',
    borderRadius: '16px'
  },
  title: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '88px',
    '& .close-button': {
      position: 'absolute',
      top: '18px',
      right: '18px',
      padding: '6px'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 20px'
    }
  },
  content: {
    padding: '0px 24px 24px',
    '& p, h6': {
      wordBreak: 'break-all'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0px 16px 24px'
    }
  },
  actions: {
    borderTop: `1px solid ${colorSet.gray400}`,
    padding: '16px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px'
    }
  }
}));
